function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m68.856 26.466-20.602 71.95 10.89 3.118 20.602-71.95ZM42.004 41.665 27.683 55.986 19.67 64l8.01 8.012 14.324 14.321 8.013-8.01L35.692 64l14.322-14.325Zm43.992 0-8.01 8.01 14.322 14.324-14.325 14.324 8.013 8.01L100.32 72.01l8.01-8.012-8.013-8.013z",
    className: "icon_svg__black",
    style: {
      fill: "#70ad54"
    }
  }));
};
export default SvgIcon;